// External libraries
import React from 'react';

// Internal modules'
import { Section } from '@/components/Form/StyledComponents';
import { ContactFieldsSection } from '@/components/ContactInformation';
import { GenericSubmission } from '@/components/Form/FormSubmission';
import { StreamlineOnboardOptions } from '@/components/OnboardOptions/StreamlineOnboardOptions';

// Optional passwordless only has streamline experience
export const OptionalPasswordless = (): JSX.Element => {
  return (
    <>
      <Section>
        <ContactFieldsSection isStreamlineExperience />
        <StreamlineOnboardOptions isPasswordless />
      </Section>
      <GenericSubmission />
    </>
  );
};
